export enum StyleOrder {
    Button = "buttons",
    Answer = "answers"
}
